import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Importing components
import { Controls } from '../../components/player/controls';
import { EndScreen } from '../../components/player/end-screen';
import { PlayerContent } from '../../components/player/player-content';
import { PauseScreen } from '../../components/player/pause-screen';
// Importing hooks
import { useShallow } from 'zustand/react/shallow';
// Importing 3rd party components
import Grid from '@mui/material/Grid';
// Importing store
import { usePlayerStore } from '../../store/player.store';
// Importing types
import { PlayerControls, PlayerType } from '../../types/player';
import { Captions } from './captions';
// ----------------------------------------------------------------------
export const VideoPlayer = () => {
    // Adding data handler
    const { available, ended, error, playing, setEnded, togglePlaying } = usePlayerStore(useShallow((state) => ({
        available: state.available,
        ended: state.ended,
        error: state.error,
        playing: state.playing,
        setEnded: state.setEnded,
        togglePlaying: state.togglePlaying,
    })));
    return (_jsxs(Grid, { container: true, position: "relative", children: [_jsx(Grid, { item: true, height: "100%", width: "100%", onClick: togglePlaying, children: _jsx(PlayerContent, { type: PlayerType.video }) }), !playing && !ended && available && !error && (_jsx(Grid, { item: true, height: '100%', onClick: togglePlaying, position: "absolute", sx: {
                    backgroundColor: 'rgba(42, 54, 132, 0.50)',
                    backdropFilter: 'blur(5px)',
                }, width: "100%", children: _jsx(PauseScreen, { type: PlayerType.video }) })), !playing && ended && (_jsx(Grid, { item: true, height: '100%', onClick: () => {
                    setEnded();
                    togglePlaying();
                }, position: "absolute", sx: {
                    backgroundColor: 'rgba(42, 54, 132, 0.50)',
                    backdropFilter: 'blur(5px)',
                }, width: "100%", children: _jsx(EndScreen, { type: PlayerType.video }) })), available && (_jsx(Grid, { item: true, bottom: 0, position: "absolute", width: "100%", children: _jsx(Controls, { controls: [
                        PlayerControls.captions,
                        PlayerControls.chapters,
                        PlayerControls.duration,
                        PlayerControls.fullscreen,
                        PlayerControls.play,
                        PlayerControls.progressBar,
                        PlayerControls.volume,
                    ] }) })), _jsx(Grid, { alignItems: 'center', display: 'flex', item: true, justifyContent: 'center', sx: { bottom: { xs: '50%', md: '15%' } }, position: "absolute", width: "100%", children: _jsx(Captions, { type: PlayerType.video }) })] }));
};
